import DialogProvider from "@components/dialog_provider"
import { oneTimesUpdate } from "@domain/coupons"
import useTranslate from "@hooks/use_translate"
import { Stack } from "@mui/material"
import { showErrorToast, showSuccessToast } from "@utils/toast"
import { OneTimesType } from "__generated__/graphql"
import { useState } from "react"

type LoadDefaultUserRoleProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function LoadDefaultUserRoles({
  isOpen,
  setIsOpen
}: LoadDefaultUserRoleProps) {
  const { translate } = useTranslate()
  const [loading, setLoading] = useState(false)

  const setClose = () => {
    setIsOpen(false)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  async function onSubmit() {
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await oneTimesUpdate({
      type: OneTimesType.LoadDefaultUserRoles,
      metaData: {}
    })
    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }

    showSuccessToast(translate("succesfully_added"))
    setLoading(false)
    handleClose()
  }
  return (
    <DialogProvider
      title={translate("load_default_user_roles")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("submit"),
        color: "primary",
        onClick: onSubmit,
        loading: loading,
        disabled: loading
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <p>{translate("load_default_user_roles_message")}</p>
      </Stack>
    </DialogProvider>
  )
}
